module.exports = __webpack_public_path__ + "static/media/articleOne.d67c4b31.webp";